import { render, staticRenderFns } from "./UserAutoComplete.vue?vue&type=template&id=ba35d5e8&scoped=true&"
import script from "./UserAutoComplete.vue?vue&type=script&lang=js&"
export * from "./UserAutoComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba35d5e8",
  null
  
)

export default component.exports